import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, MapPinIcon, BriefcaseIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const chips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: MapPinIcon,
  label: 'Para Argentina'
}, {
  icon: BriefcaseIcon,
  label: 'Emprendedores'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-83" data-mp="nb6kflpmn9kz">
      <div className="mx-auto max-w-4xl px-5 pt-[13px] pb-[5px] text-center sm:pt-16" style={{
      paddingTop: "22px"
    }} data-id="element-84" data-mp="3d1ii934hv0k9">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-celeste" style={{
        color: "#E9C25F"
      }} data-id="element-85" data-mp="381xiwrlewq70">
          🏆 SIGMA SMART™
        </motion.p>

        <span className="font-display text-[26px] font-bold text-[#E9C25F] sm:text-[30px]" style={{
        color: "#74ACDF"
      }} data-id="element-86" data-mp="39autvl4lu10x">
          Tu marca de ropa que siempre soñaste, resuelta desde hoy
        </span>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-display pt-[7px] pb-[18px] text-center text-[18px] font-extrabold tracking-tight text-celeste sm:text-5xl" style={{
        color: "#E9C25F",
        fontSize: "16px",
        fontWeight: "600",
        paddingTop: "11px",
        paddingBottom: "27px"
      }} data-id="element-87" data-mp="30gzwiz9q5evu">
          MasterPack Marca Propia Argentina ™
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md" data-id="element-88" data-mp="2lkiiu1e2bo64">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-celeste/25 blur-3xl" data-id="element-89" data-mp="nb1kz5gpvtwy" />
          <img src="https://cdn.magicpatterns.com/uploads/2TLqpW311nrHQrtzViRqV5/ChatGPT_Image_1_ago_2026,_17_00_55.png" alt="MasterPack Marca Propia Argentina — 12 tomos y 5 bonos en formato digital" className="animate-floaty mx-auto h-[280px] w-[280px] max-w-full rounded-2xl object-contain" data-id="element-90" data-mp="id02aln7dwm0" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-3 pt-[5px] text-xs font-semibold uppercase tracking-[0.18em] text-[#828385]" data-id="element-91" data-mp="162m137zny9th">
          El sistema N°1 para lanzar tu marca de ropa en Argentina
        </motion.p>

        <div className="mt-9" data-id="element-92" data-mp="3lqugltxj6h7p">
          <div className="mt-6" data-id="element-93" data-mp="3hrlkwjixk99i">
            <CTAButton href="#value" data-id="element-94" data-mp="3hqkb0idnhstd">Ver la oferta</CTAButton>
            <p className="mx-auto mt-4 max-w-2xl text-[14px] text-white/70 sm:text-lg" data-id="element-95" data-mp="1x9kwertfdeju">
              Todo lo que necesitás para crear tu marca, elegir proveedores serios y vender con
              margen real. Sin improvisar. Sin quemar tus ahorros en stock que no sale.
            </p>
          </div>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-6 max-w-2xl text-[16px] font-bold text-celeste sm:text-xl" data-id="element-96" data-mp="2b1966og7bqxn">
            Nicho + Proveedor + Costos + Marca + Lanzamiento + Meta Ads
          </motion.h2>

          <div className="mt-7 flex flex-wrap justify-center gap-2.5 pt-[7px]" data-id="element-97" data-mp="2p1jv3lxyavg6">
            {chips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/80" data-id="element-98" data-mp="2tx7nea7qc4pw">
                <Icon className="h-3.5 w-3.5 text-celeste" data-id="element-99" data-mp="zm2lbacak0co" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 pt-[7px] pb-[6px] text-sm font-semibold text-white/50" data-id="element-100" data-mp="4dgumm1lb73w">
            12 Tomos · 5 Bonos · +100 páginas
· TODO RESUELTO ·
          </p>
        </div>

        <div className="mt-[10px] mb-[10px] flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-101" data-mp="e91vgguxa1c2">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-102" data-mp="3hqsdg8ffnzjz">
              <Icon className="h-4 w-4 text-gold" data-id="element-103" data-mp="3cs8qq5t0mjqk" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="mt-[18px] mb-[18px] inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-[4px] text-xs font-bold uppercase tracking-wide text-gold" data-id="element-104" data-mp="3rh55smthox0o">
          🔥 Oferta de lanzamiento — El precio cierra pronto · No vuelve
        </motion.div>
      </div>
    </header>;
}